<mat-card class="row box-shadow">
  <mat-card-header>
    <mat-card-title class="col-12">
      <h3 class="col-12">Modifier ma réservation</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

        <div class="col-12 marge">
          <div class="row">
            <div class="col-sm-5 col-12">
                <div class="row row-no-gutters">
                    <mat-form-field class="col-sm-6">
                        <input matInput [matDatepicker]="picker" [min]="start" [max]="start" disabled placeholder="début de réservation" [(value)]="start">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <div class="col-sm-6">
                      <div class="row">
                        <mat-form-field class="col-sm-6">
                          <mat-select disabled [(value)]="hour" >
                            <mat-option value="0">00</mat-option>
                            <mat-option value="1">01</mat-option>
                            <mat-option value="2">02</mat-option>
                            <mat-option value="3">03</mat-option>
                            <mat-option value="4">04</mat-option>
                            <mat-option value="5">05</mat-option>
                            <mat-option value="6">06</mat-option>
                            <mat-option value="7">07</mat-option>
                            <mat-option value="8">08</mat-option>
                            <mat-option value="9">09</mat-option>
                            <mat-option value="10">10</mat-option>
                            <mat-option value="11">11</mat-option>
                            <mat-option value="12">12</mat-option>
                            <mat-option value="13">13</mat-option>
                            <mat-option value="14">14</mat-option>
                            <mat-option value="15">15</mat-option>
                            <mat-option value="16">16</mat-option>
                            <mat-option value="17">17</mat-option>
                            <mat-option value="18">18</mat-option>
                            <mat-option value="19">19</mat-option>
                            <mat-option value="20">20</mat-option>
                            <mat-option value="21">21</mat-option>
                            <mat-option value="22">22</mat-option>
                            <mat-option value="23">23</mat-option>
                  
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-sm-6">
                          <mat-select  disabled [(value)]="min" >
                            <mat-option value="0"> 00</mat-option>
                            <mat-option value="30"> 30</mat-option>
                          </mat-select>
                        </mat-form-field>
                  
                      </div>
                    </div>
                  </div>
            </div>
            <div class="col-2 mid d-none d-sm-block">
              <mat-icon  aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
            </div>
            <div class="col-lg-5 col-12 end">
              <label>
                  <app-book-extend-form [book]="book"></app-book-extend-form>
              </label>
            </div>
          </div>
        </div>


    <h4 class="col-12">Disponibilité de la station</h4>
    <div class="col-12">
      <app-station-availabilities-graph [userBook]="book"></app-station-availabilities-graph>
    </div>
  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>
</mat-card>
